import React from 'react';
import { string, number } from 'prop-types';
import { Mutation } from 'react-apollo';
import {
  Container,
  Row,
  Column,
  Heading,
  Paragraph,
  HtmlParser,
  LazyLoadImg,
  LoadingIndicator,
} from 'components/common';
import ErrorPage from 'pages/ErrorPage';
import withApplicationConfig from 'containers/withApplicationConfig';
import StopNewsletterSubscription from '../../queries/stopNewsletterSubscription.gql';
import './Unsubscribe.scss';

const Unsubscribe = ({
  title,
  subTitle,
  p1,
  imgAlt,
  token,
  goodbyeImgDesktop,
  goodbyeImgMobile,
  imgWidth,
  mobileImgWidth,
}) => {
  if (!token) {
    return (<ErrorPage errorCode={404} />);
  }
  return (
    <Mutation
      mutation={StopNewsletterSubscription}
      variables={{
        token,
      }}
    >
      {(mutate, {
        error,
        data,
        loading,
        called,
      }) => {
        if (error) {
          throw new Error(error);
        }

        if (!called) {
          mutate();
        }

        if (data && data.stopNewsletterSubscription) {
          return (
            <div
              className="unsubscribe"
            >
              <Container>
                <Row>
                  <Column md={12} className="goodbye-mobile">
                    <LazyLoadImg
                      className="column-image"
                      src={goodbyeImgMobile}
                      alt={imgAlt}
                      width={mobileImgWidth}
                    />
                  </Column>
                  <Column md={7} className="goodbye-message">
                    <Heading
                      as="h1"
                    >
                      {title}
                    </Heading>
                    <Heading as="h2">{subTitle}</Heading>
                    <Paragraph><HtmlParser htmlString={p1} /></Paragraph>
                  </Column>
                  <Column md={5} className="goodbye-desktop">
                    <LazyLoadImg
                      className="column-image"
                      src={goodbyeImgDesktop}
                      alt={imgAlt}
                      width={imgWidth}
                    />
                  </Column>
                </Row>
              </Container>
            </div>
          );
        }
        if (!loading && data && data.stopNewsletterSubscription === false) {
          throw Error('Error when unsubscribing');
        }
        return (
          <LoadingIndicator />
        );
      }}
    </Mutation>
  );
};

Unsubscribe.defaultProps = {
  title: '',
  subTitle: '',
  p1: '',
  imgAlt: '',
};

Unsubscribe.propTypes = {
  title: string,
  subTitle: string,
  p1: string,
  imgAlt: string,
  imgWidth: number.isRequired,
  mobileImgWidth: number.isRequired,
  token: string.isRequired,
  goodbyeImgDesktop: string.isRequired,
  goodbyeImgMobile: string.isRequired,
};

export default withApplicationConfig(Unsubscribe, 'unsubscribePage');
